<template>
    <div id="productadd">
       <HeaderNav :is_dialogpage="true" :routername="this.$route.name" :addoredirtname="addoredirtname"></HeaderNav>
       
       <div class="room-form-page">
           <!-- 基本信息卡片 -->
           <div class="form-card">
               <div class="card-header">
                   <span class="card-icon">&#128718;</span>
                   <h3>基本信息</h3>
               </div>
               <div class="card-body">
                   <div class="form-row">
                       <div class="form-group">
                           <label>房间名称</label>
                           <input placeholder="请输入房间名称" v-model="formData.roomName" />
                       </div>
                       <div class="form-group">
                           <label>房间分类</label>
                           <select v-model="formData.roomType">
                               <option value="">请选择房间分类</option>
                               <option v-for="item in categoryList" :key="item.id" :value="item.id">{{ item.name }}</option>
                           </select>
                       </div>
                   </div>
                   <div class="form-row">
                       <div class="form-group full-width">
                           <label>房间描述</label>
                           <input type="text" placeholder="请输入房间描述" v-model="formData.roomDesc" />
                       </div>
                   </div>
                   <div class="form-row">
                       <div class="form-group">
                           <label>房间价格(元/天)</label>
                           <input type="number" step="0.01" placeholder="请输入房间价格" v-model="formData.roomPice" />
                       </div>
                       <div class="form-group">
                           <label>房间面积(m&sup2;)</label>
                           <input type="number" step="0.01" placeholder="请输入房间面积" v-model="formData.roomArea" />
                       </div>
                       <div class="form-group">
                           <label>房间容积</label>
                           <input type="text" placeholder="请输入房间容积" v-model="formData.roomSize" />
                       </div>
                   </div>
                   <div class="form-row">
                       <div class="form-group">
                           <label>楼层</label>
                           <input type="text" placeholder="请输入楼层" v-model="formData.roomFloor" />
                       </div>
                       <div class="form-group">
                           <label>预约信息</label>
                           <input type="text" placeholder="请输入预约信息" v-model="formData.roomReservation" />
                       </div>
                   </div>
               </div>
           </div>

           <!-- 房型信息卡片 -->
           <div class="form-card">
               <div class="card-header">
                   <span class="card-icon">&#128716;</span>
                   <h3>房型信息</h3>
               </div>
               <div class="card-body">
                   <div class="form-row">
                       <div class="form-group">
                           <label>窗户类型</label>
                           <select v-model="formData.roomWindowType">
                               <option value="">请选择窗户类型</option>
                               <option v-for="item in produtWindowTypeList" :key="item.id" :value="item.id">{{ item.name }}</option>
                           </select>
                       </div>
                       <div class="form-group">
                           <label>床型</label>
                           <select v-model="formData.roomBedType">
                               <option value="">请选择床型</option>
                               <option v-for="item in produtBedTypeList" :key="item.id" :value="item.id">{{ item.name }}</option>
                           </select>
                       </div>
                   </div>
                   <div class="form-row">
                       <div class="form-group full-width">
                           <label>床型描述</label>
                           <input type="text" placeholder="请输入床型描述" v-model="formData.roomBedDesc" />
                       </div>
                   </div>
               </div>
           </div>

           <!-- 房间设施卡片 -->
           <div class="form-card">
               <div class="card-header">
                   <span class="card-icon">&#9989;</span>
                   <h3>房间设施</h3>
               </div>
               <div class="card-body">
                   <div class="facility-grid">
                       <div class="facility-item" v-for="item in produtAttrlist" :key="item.id">
                           <CheckBox v-model="produtAttrArr" :lable="item.name" :value="item.id" :type="'checkbox1'"></CheckBox>
                       </div>
                   </div>
               </div>
           </div>

           <!-- 房间图片卡片 -->
           <div class="form-card">
               <div class="card-header">
                   <span class="card-icon">&#128247;</span>
                   <h3>房间图片</h3>
               </div>
               <div class="card-body">
                   <div class="pic-grid">
                       <div class="pic-preview" v-for="item,index in formData.roomPic" :key="index">
                           <a href="javascript:void(0)" class="pic-del" @click="deletepic(index)">&times;</a>
                           <img :src="item" @click="showimg(item)">
                       </div>
                       <div class="pic-upload" v-if="!productImg&&formData.roomPic.length<6">
                           <PicInput v-model="productImg" :inputid="'p1'" :key="comkey"/>
                       </div>
                   </div>
               </div>
           </div>

           <!-- 房间详情卡片 -->
           <div class="form-card">
               <div class="card-header">
                   <span class="card-icon">&#128196;</span>
                   <h3>房间详情</h3>
               </div>
               <div class="card-body">
                   <div class="editor-container">
                        <Toolbar
                            style="border-bottom: 1px solid #eee"
                            :editor="editorRef"
                            :defaultConfig="toolbarConfig"
                            :mode="mode"
                        />
                        <Editor
                            style="height: 400px; overflow-y: hidden;"
                            v-model="formData.roomInfo"
                            :defaultConfig="editorConfig"
                            :mode="mode"
                            @onCreated="handleCreated"
                        />
                   </div>
               </div>
           </div>

           <!-- 底部按钮 -->
           <div class="form-footer">
               <a href="javascript:void(0)" class="btn-cancel" @click="closepage(0)">取消</a>
               <a href="javascript:void(0)" class="btn-submit" @click="handleSubmit">提交</a>
           </div>
       </div>
   </div>
   <div id="showimgbox" v-if="this.showimg_src" @click.self="this.closeshowimgbox">
         <a href="javascript:void(0);" @click="this.closeshowimgbox">关闭</a>
         <img :src="this.showimg_src" @load="loadimgfun" ref="imageElement" :style="{width:this.show_img_width+'px',
            height:this.show_img_height+'px',marginTop:(0-(this.show_img_height/2))+'px',marginLeft:(0-(this.show_img_width/2))+'px'}"></img>
   </div>
</template>

<script>
import HeaderNav from '../common/HeaderNav.vue';
import { ElMessage } from 'element-plus';
import '@wangeditor/editor/dist/css/style.css' 
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import http from '@/tools/Http';
// 请根据实际项目 API 文件路径引入对应的接口
import { addRoom, updateRoom,selectRoomById} from '@/tools/Api';
import PicInput from '../common/PicInput.vue';
import Selectself from '../common/Selectself.vue'; // 1. 引入组件
import CheckBox from '../common/CheckBox.vue';

export default {
   name: "ProductAdd",
   data() {
       return {
           addoredirtname: "",
           showimg_src: "",
           show_img_width: 0,
           show_img_height: 0,
           inputimgarr: [],//酒店图片
           produtAttrArr: [],
           comkey:0,
           productImg: "",//接受文件控件返回值
           storeList: [],      // 3. 酒店选项列表
           storeDataLoad: false, // 4. 酒店数据加载状态
           
           // 房间分类列表
           categoryList: [
               { id: 1, name: "大床房" },
               { id: 2, name: "主题房" },
               { id: 3, name: "标间" },
               { id: 4, name: "单间" }
           ],
            // 房间床型列表1-大床；2-小床；3-单人床；4-双人床；5-混合
            produtBedTypeList: [
               { id: 1, name: "大床" },
               { id: 2, name: "小床" },
               { id: 3, name: "单人床" },
               { id: 4, name: "双人床" },
               { id: 5, name: "混合" }
           ],
           produtWindowTypeList:[
               { id: 1, name: "有窗" },
               { id: 2, name: "无窗" },
               { id: 3, name: "部分有窗" }
           ],
           produtAttrlist:[
               { id: 1, name: "电视" },
               { id: 2, name: "冰箱" },
               { id: 3, name: "洗衣机" },
               { id: 4, name: "空调" },
               { id: 5, name: "电热水器" },
               { id: 6, name: "书桌" },
               { id: 7, name: "沙发" },
               { id: 8, name: "独立卫浴" },
               { id: 9, name: "衣柜" },
               { id: 10, name: "吹风机" },
               { id: 11, name: "拖鞋" },
               { id: 12, name: "洗漱用品" },
               { id: 13, name: "WIFI" },
               { id: 14, name: "电话" },
               { id: 15, name: "瓶装水" }
           ],
           // 表单数据对象
          formData: {
            roomPic: [],//5
            roomPice: '',//4
            roomArea: '',
            roomAttr: "",
            roomBedDesc: "",
            roomBedType: '',
            roomFloor: "",
            roomInfo: "",//
            roomName: "",//1
            roomReservation: "",
            roomSize: "",
            roomType: '',
            roomWindowType: "",
            roomDesc:'',
            roomStoreId: "",
           },
           // --- 富文本相关 ---
           editorRef: null, 
           mode: 'default', 
           toolbarConfig: {
               excludeKeys: ['insertVideo', 'uploadVideo'], 
           },
           editorConfig: {
               placeholder: '请输入房间详细介绍...',
               MENU_CONF: {
                    uploadImage: {
                        customUpload: async (file, insertFn) => {
                            const formData = new FormData()
                            formData.append('file', file)
                            try {
                                const res = await this.uploadImageToServer(formData)
                                insertFn(res.fileFullPath, '', '')
                            } catch (error) {
                                console.error('上传失败', error)
                            }
                        }
                    }
                }
            }
       };
   },

   components: {
       HeaderNav,
       Editor,
       Toolbar,
       PicInput,
       Selectself, // 2. 注册组件
       CheckBox
   },
   props: {
       is_edirt: {
           type: Boolean,
           required: true
       },
       roomId: { 
           type: [Number, String],
           default: ""
       }
   },
   watch: {
    // 监听message的变化
    productImg(newVal, oldVal) {
      this.inputimgarrfun()
    }
  },
   mounted() {
       if (this.is_edirt) {
           this.addoredirtname = "修改";
           this.getProductInfo();
       } else {
           this.addoredirtname = "新增";
       }
   },
   beforeUnmount() {
       const editor = this.editorRef
       if (editor == null) return
       editor.destroy()
   },
   methods: {
       getProductArrStr(){
          const str="000000000000000"
          let arr = str.split('');

          for(let i=0;i<this.produtAttrArr.length;i++){
              arr[this.produtAttrArr[i]-1]=1
          }
          console.log(arr.join('')) 
          this.formData.roomAttr=arr.join('')

       },
       setProductArrStr(){
          const str=this.formData.roomAttr
          let arr = str.split('');

          for(let i=0;i<arr.length;i++){
            if(arr[i]==1){
                this.produtAttrArr.push(this.produtAttrlist[i].id)
            }
          }
       },
    getProductInfo(){
        selectRoomById({roomId:this.roomId}).then(res => {
            if (res.status == 0) {
                const data = res.data;
                this.formData = {
                    ...res.data
                }
                // 接口返回单位为分，转换为元展示
                if (this.formData.roomPice != null && this.formData.roomPice !== '') {
                    this.formData.roomPice = (Number(this.formData.roomPice) / 100).toFixed(2);
                }
                this.setProductArrStr()
            }else{
                ElMessage({
                    message: res.msg || "操作失败",
                    type: 'error',
                    duration: 1500
                });
            }
        }).catch(error => {
            ElMessage({
                message: "请求失败！",
                type: 'error',
                duration: 1500
            });
        });
    },
    inputimgarrfun(){
        if(this.productImg==''){
            return
        }
       
        this.formData.roomPic.push(this.productImg.fileFullPath)
        this.productImg=''
        this.comkey+=1

    },
    closeshowimgbox(){
        this.showimg_src=""
        this.show_img_width=0
        this.show_img_height=0
    },
    async loadimgfun(){
        let w=0
        let h=0
        const img = new Image()
        img.src = this.showimg_src
        await new Promise((resolve) => {
            img.onload = () => {
                w= img.width
                h= img.height
                if(w>h){ 
                    this.show_img_width=600;
                    this.show_img_height=Math.round(600/w*h);
                }else{
                    this.show_img_height=600;
                    this.show_img_width=Math.round(600/h*w);
                }
                resolve()
            }
        })
    },
    deletepic(index){
        if(this.formData.roomPic.length==1){ 
             ElMessage({ message: "房间图片必须要存在一张！", type: 'error', duration: 1500 });
             return
        }
        this.formData.roomPic.splice(index,1)
    },
    showimg(src){
        this.showimg_src=src;
    },
    async uploadImageToServer (formData) { 
        const date=await  http.post('/file/uplaods',formData,{
            headers:{
                'Content-Type':'multipart/form-data'
            }
        }).then(res=>{
            if(res.status==0){
                return res.data
            }
        }).catch(error=>{
        })
        return date
    },
    handleCreated(editor) {
        this.editorRef = editor;
    },
    closepage(isrush) {
        this.resetForm();
        if (isrush == 1) {
            this.$emit('closerush');
        } else {
            this.$emit('closepage');
        }
    },
    handleSubmit() {
        if (!this.checkInput()) {
            return;
        }
        this.getProductArrStr()
        const params = {
            ...this.formData
        };

        if (this.is_edirt) {
            params.roomId = this.roomId; 
        }

        // 提交时元转分
        if (params.roomPice != null && params.roomPice !== '') {
            params.roomPice = Math.round(Number(params.roomPice) * 100);
        }
        const apiCall = this.is_edirt ? updateRoom(params) : addRoom(params);

        apiCall.then(res => {
            if (res.status == 0) {
                ElMessage({
                    message: this.is_edirt ? "修改成功！" : "新增成功！",
                    type: 'success',
                    duration: 1500
                });
                this.closepage(1); 
            } else {
                ElMessage({
                    message: res.msg || "操作失败",
                    type: 'error',
                    duration: 1500
                });
            }
        }).catch(err => {
            ElMessage({
                message: "请求失败！",
                type: 'error',
                duration: 1500
            });
        });
    },
    checkInput() {
        if (!this.formData.roomName || this.formData.roomName.trim().length < 1) {
            ElMessage({ message: "房间名称不能为空！", type: 'error', duration: 1500 });
            return false;
        }
        if (!this.formData.roomPice ==null || this.formData.roomPice==0) {
            ElMessage({ message: "房间价格不能为空！", type: 'error', duration: 1500 });
            return false;
        }
        if (this.formData.roomPic.length == 0) {
            ElMessage({ message: "房间图片必须要存在一张！", type: 'error', duration: 1500 });
            return false;
        }
        return true;
    },
    resetForm() {
        this.formData = {
           roomPic: [],//5
            roomPice: '',//4
            roomArea: '',
            roomAttr: "",
            roomBedDesc: "",
            roomBedType: '',
            roomFloor: "",
            roomInfo: "",//
            roomName: "",//1
            roomReservation: "",
            roomSize: "",
            roomType: '',
            roomWindowType: "",
            roomDesc:'',
            roomStoreId: "",
        };
        if (this.editorRef) {
            this.editorRef.setHtml('');
        }
    }
   }
};
</script>

<style scoped>
#productadd {
   width: 100%;
   height: 100%;
   position: absolute;
   background-color: #f5f6f8;
   left: 0;
   top: 0;
   z-index: 20;
}

.room-form-page {
   width: 100%;
   height: calc(100% - 40px);
   float: left;
   padding: 24px 40px;
   overflow-y: auto;
   box-sizing: border-box;
}

/* 表单卡片 */
.form-card {
   background: #fff;
   border-radius: 10px;
   margin-bottom: 20px;
   box-shadow: 0 2px 12px rgba(0,0,0,0.06);
   overflow: hidden;
}
.card-header {
   display: flex;
   align-items: center;
   gap: 10px;
   padding: 16px 28px;
   border-bottom: 1px solid #f0f0f0;
   background: #fafbfc;
}
.card-header h3 { margin: 0; font-size: 16px; color: #333; font-weight: 600; }
.card-icon { font-size: 20px; }
.card-body { padding: 24px 28px; }

/* 表单行 */
.form-row { display: flex; gap: 24px; margin-bottom: 20px; }
.form-row:last-child { margin-bottom: 0; }
.form-group { flex: 1; display: flex; flex-direction: column; gap: 8px; }
.form-group.full-width { flex: none; width: 100%; }
.form-group label { font-size: 14px; color: #555; font-weight: 500; }
.form-group input,
.form-group select {
   height: 42px; border: 1px solid #dcdfe6; border-radius: 6px;
   outline: none; font-size: 14px; padding: 0 12px; color: #333;
   transition: border-color 0.2s, box-shadow 0.2s; background-color: #fff;
}
.form-group input:focus,
.form-group select:focus { border-color: #12ab04d4; box-shadow: 0 0 0 3px rgba(18,171,4,0.1); }
.form-group input::placeholder { color: #bbb; }

/* 设施网格 */
.facility-grid { display: flex; flex-wrap: wrap; gap: 8px; }
.facility-item { width: calc(20% - 8px); }

/* 图片上传 */
.pic-grid { display: flex; flex-wrap: wrap; gap: 12px; }
.pic-preview {
   width: 130px; height: 100px; border-radius: 8px; overflow: hidden;
   position: relative; border: 1px solid #eaeaea; cursor: pointer; transition: all 0.3s;
}
.pic-preview:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.12); transform: translateY(-2px); }
.pic-preview img { width: 100%; height: 100%; object-fit: cover; }
.pic-del {
   position: absolute; top: 4px; right: 4px; width: 20px; height: 20px;
   line-height: 18px; text-align: center; background: rgba(229,57,53,0.9);
   color: #fff; border-radius: 50%; font-size: 14px; text-decoration: none; z-index: 2;
}
.pic-del:hover { background: rgba(229,57,53,1); }
.pic-upload { width: 130px; height: 100px; }

/* 富文本编辑器 */
.editor-container { border: 1px solid #dcdfe6; border-radius: 6px; overflow: hidden; }

/* 底部按钮 */
.form-footer { display: flex; justify-content: center; gap: 20px; padding: 20px 0 40px; }
.form-footer a {
   display: inline-block; width: 120px; height: 42px; line-height: 42px;
   text-align: center; border-radius: 8px; font-size: 15px; font-weight: 500;
   text-decoration: none; transition: all 0.3s;
}
.btn-cancel { background: #fff; color: #666; border: 1px solid #dcdfe6; }
.btn-cancel:hover { color: #12ab04d4; border-color: #12ab04d4; background: #f0f9eb; }
.btn-submit {
   background: linear-gradient(135deg, #12ab04d4, #0d8a03);
   color: #fff; border: none; box-shadow: 0 4px 12px rgba(18,171,4,0.3);
}
.btn-submit:hover { box-shadow: 0 6px 16px rgba(18,171,4,0.4); transform: translateY(-1px); }

/* 图片全屏预览 */
#showimgbox {
    width: 100%; height: 100%; position: fixed; z-index: 50; top: 0; left: 0;
    background-color: rgba(0,0,0,0.7);
}
#showimgbox img { position: absolute; top: 50%; left: 50%; border-radius: 6px; }
#showimgbox a {
    width: auto; height: 40px; position: absolute; top: 10px; right: 10px;
    display: block; color: #fff; text-align: center; line-height: 40px;
    text-decoration: none; background: rgba(0,0,0,0.4); padding: 0 16px;
    border-radius: 20px; font-size: 14px; transition: background 0.3s;
}
#showimgbox a:hover { background: rgba(0,0,0,0.6); }
</style>